import { api } from "./api";

export const sessionService = {
    getById: async (id) => {
        return api.get(`/sessions/${id}`);
    },
    checkIn: async (id) => {
        return api.post(`/sessions/${id}/checkin`);
    },
    join: async (id) => {
        return api.post(`/sessions/${id}/join`);
    },
    complete: async (id) => {
        return api.put(`/sessions/${id}/complete`);
    },
    checkCanRate: async (id) => {
        return api.get(`/sessions/${id}/can-rate`);
    },
    submitRating: async (id, data) => {
        return api.post(`/sessions/${id}/rate`, data);
    }
};
